<template>
  <div>
    <div
      v-if="loading"
      id="carregaDados"
      class="text-center"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando Dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div>
      <div id="map" />
      <div
        id="idTable"
        style="overflow-x: auto;"
      >
        <table
          style="width: 100%; color: black; border-collapse: collapse;"
          class="elevation-1"
          mobile-breakpoint="0"
        >
          <tbody>
            <tr
              v-for="item in supervisorLegenda"
              :key="item.id"
            >
              <td
                id="dadoMovimentacao"
                style="text-align: center;"
              >
                <v-chip
                  class="pa-2 rounded-circle"
                  :color="item.cor"
                  x-small
                  dark
                />
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: left;"
              >
                {{ item.nome_supervisor }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.porcentagem }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import Time from '../../../../services/time4'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    data () {
      return {
        map: null,
        markers: [],
        center: {
          lat: -20.7523412,
          lng: -42.8732878,
          name: 'Magistech',
        },
        marker: '',
        indiceLegenda: [],
        currentLocation: null,
        primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
        dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
        select: [],
        supervisor: [],
        receita: [],
        segmento: [],
        rede: [],
        categoria: [],
        promotor: [],
        area: [],
        classificacao: [],
        linhaProducao: [],
        cepGeocalizacao: [],
        window_open: false,
        info_marker: null,
        infowindow: {
          lat: -20.7523412,
          lng: -42.8732878,
          tooltip: 'Magistech',
        },
        locations: [],
        supervisorLegenda: [],
        headersSupervisores: [
          { text: 'Cor', value: 'cor', align: 'right', class: 'black--text title' },
          { text: 'Nome Supervisor', value: 'nome_supervisor', align: 'left', class: 'black--text title', sytle: 'margin-left: -1rem' },
          { text: 'Quantidade', value: 'numero', align: 'right', class: 'black--text title' },
          { text: 'Porcentagem', value: 'porcentagem', align: 'right', class: 'black--text title' },
        ],
        corsLegend: [
          { corBackground: '#ea4335', corGlyph: '#b31412' },
          { corBackground: '#64B5F6', corGlyph: '#2196F3' },
          { corBackground: '#8D6E63', corGlyph: '#795548' },
          { corBackground: '#26A69A', corGlyph: '#009688' },
          { corBackground: '#C8E6C9', corGlyph: '#4CAF50' },
          { corBackground: '#FFF176', corGlyph: '#FBC02D' },
          { corBackground: '#FFB74D', corGlyph: '#FF9800' },
          { corBackground: '#EEEEEE', corGlyph: '#9E9E9E' },
          { corBackground: '#BA68C8', corGlyph: '#9C27B0' },
        ],
        loading: false,
        error: null,
        styleObject: {
          color: localStorage.corPrimaria,
        },
        infoWindow: '',
      }
    },

    created () {
      eventEmit.$on('update-localizcao', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-localizcao', this.handleUpdateDados)
    },

    mounted () {
      this.loadMap()
    },

    methods: {
      async loadMap () {
        // Exemplo de uso da API do Google Maps
        const map = await new window.google.maps.Map(document.getElementById('map'), {
          center: this.center,
          zoom: 14,
          mapId: '6ae34073275a94e4',
        })

        // eslint-disable-next-line no-unused-vars
        const markerView = await new window.google.maps.marker.AdvancedMarkerView({
          map,
          position: this.center,
          title: this.center.name,
        })
      },

      handleUpdateDados (primeiroDia, dataFinal, select, supervisor, receita, segmento, rede, categoria, promotor, area, classificacao, linhaProducao) {
        this.primeiroDia = primeiroDia
        this.dataFinal = dataFinal
        this.select = select
        this.supervisor = supervisor
        this.receita = receita
        this.segmento = segmento
        this.rede = rede
        this.categoria = categoria
        this.promotor = promotor
        this.area = area
        this.classificacao = classificacao
        this.linhaProducao = linhaProducao

        this.mapaInicial()

        this.atualizaGrafico()
      },

      mapaInicial () {
        this.clientesLegenda = []
        this.locations = []
        this.center = {
          lat: -20.7523412,
          lng: -42.8732878,
          name: 'Magistech',
        }

        const map = new window.google.maps.Map(document.getElementById('map'), {
          center: this.center,
          zoom: 14,
          mapId: '6ae34073275a94e4',
        })

        // eslint-disable-next-line no-unused-vars
        const markerView = new window.google.maps.marker.AdvancedMarkerView({
          map,
          position: this.center,
          title: this.center.name,
        })
      },

      async atualizaGrafico () {
        this.loading = true

        await Time.showLocalizacaoTime4(this.primeiroDia, this.dataFinal, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.segmento, this.rede, this.categoria, this.promotor, this.area, this.classificacao, this.linhaProducao).then(resposta => {
          if (resposta.data.status) {
            this.supervisorLegenda = resposta.data.supervisor.map((item, i) => {
              var listaLegenda = ({
                nome_supervisor: item.nome_supervisor,
                numero: item.numero,
                porcentagem: item.porcentagem + '%',
                cor: this.corsLegend[item.cod_supervisor].corBackground,
              })

              return listaLegenda
            })

            this.locations = resposta.data.codGeocalizacao.map((item, i) => {
              var listaLocations = ({
                lat: item.latitude,
                lng: item.longitude,
                tooltip: item.nome_legenda,
                corBackground: this.corsLegend[item.cod_supervisor].corBackground,
                corGlyph: this.corsLegend[item.cod_supervisor].corGlyph,
              })

              return listaLocations
            })

            this.center = this.locations[0]

            this.setMarker()
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      setMarker () {
        const contentCenter = { background: this.center.corBackground, glyphColor: this.center.corGlyph, borderColor: this.center.corBackground }

        const map = new window.google.maps.Map(document.getElementById('map'), {
          center: this.center,
          zoom: 12,
          mapId: '6ae34073275a94e4',
          title: this.center.tooltip,
          content: contentCenter,
        })

        // Create an info window to share between markers.
        const infoWindow = new window.google.maps.InfoWindow()

        this.locations.forEach(location => {
          // Adicionar cor marcadores
          const pinViewBackground = new window.google.maps.marker.PinView({
            background: location.corBackground,
            glyphColor: location.corGlyph,
            borderColor: location.corBackground,
          })

          // Adicionar marcadores
          const marker = new window.google.maps.marker.AdvancedMarkerElement({
            position: { lat: location.lat, lng: location.lng },
            map: map,
            title: location.tooltip,
            content: pinViewBackground.element,
          })

          marker.addListener('gmp-click', (event) => {
            infoWindow.close()
            infoWindow.setContent(marker.title)
            infoWindow.open(marker.map, marker)
          })

          this.markers.push(marker)
        })
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 680px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #map {
    height: 400px;
  }
</style>
